/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MessageListAliases {
  CHECKBOX_PRIORITY = 'checkbox-priority',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_MESSAGE_NOT_READ = 'fetch-message-not-read',
  FETCH_MESSAGE_READ = 'fetch-message-read',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_PRIORITY = 'field-priority',
  FIELD_SUBJECT = 'field-subject',
  FILTER = 'filter',
  INPUT_DESCRIPTION = 'input-description',
  INPUT_SUBJECT = 'input-subject',
  LAYOUT_MESSAGE = 'layout-message',
  PAGINATOR_MESSAGE_NOT_READ = 'paginator-message-not-read',
  PAGINATOR_MESSAGE_READ = 'paginator-message-read',
  PANEL_LIST = 'panel-list',
  PANEL_TAB_MESSAGE_NOT_READ = 'panel-tab-message-not-read',
  PANEL_TAB_MESSAGE_READ = 'panel-tab-message-read',
  TAB_CONTROL_MESSAGE = 'tab-control-message',
  TAB_MESSAGE_NOT_READ = 'tab-message-not-read',
  TAB_MESSAGE_READ = 'tab-message-read',
  TABLE_COLUMN_ACTIONS = 'table-column-actions',
  TABLE_COLUMN_MESSAGE_ACTIONS = 'table-column-message-actions',
  TABLE_COLUMN_MESSAGE_NOT_READ_SUBJECT = 'table-column-message-not-read-subject',
  TABLE_COLUMN_MESSAGE_NOT_READ_URGENT = 'table-column-message-not-read-urgent',
  TABLE_COLUMN_MESSAGE_READ_DATE_READ = 'table-column-message-read-date-read',
  TABLE_COLUMN_MESSAGE_READ_SUBJECT = 'table-column-message-read-subject',
  TABLE_COLUMN_MESSAGE_READ_URGENT = 'table-column-message-read-urgent',
  TABLE_COLUMN_MESSAGE_SENT_DATE = 'table-column-message-sent-date',
  TABLE_MESSAGE_NOT_READ = 'table-message-not-read',
  TABLE_MESSAGE_READ = 'table-message-read',
}
export { MessageListAliases };
